import { Map } from 'immutable'
import { createSelector } from 'reselect'

const selfServiceConfig = (state) => state.getIn(['selfServiceConfig', 'data'])

export const selectSelfServiceConfig = createSelector(
  [selfServiceConfig],
  (selfServiceConfig) => selfServiceConfig || new Map()
)
